function initThreeUpsSlider() {
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const $sliders = $(".three-ups-section__slider");

  if (windowWidth < 1000) {
    $sliders.each(function () {
      const $this = $(this);
      if (!$this.hasClass("flickity-enabled")) {
        $this.flickity({
          cellAlign: "left",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: true,
        });
      }
    });
  } else {
    $sliders.filter(".flickity-enabled").flickity("destroy");
  }
}

$(document).ready(initThreeUpsSlider);

// Unique resize timer
window.resizeTimerThreeUps = window.resizeTimerThreeUps || null;
$(window).on("resize", function () {
  clearTimeout(window.resizeTimerThreeUps);
  window.resizeTimerThreeUps = setTimeout(initThreeUpsSlider, 250);
});
